<template>
  <div class="container">
    <div class="row">
      <div class="col-12 mt-3">
        <h3>Sorry we could not find what you were looking for</h3>
        <button
          type="button"
          class="btn btn-primary btn-lg"
          @click="$router.push('/')"
        >
          &lt; Take me back to safety
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
    name: 'RouteNotFoundPage'
}
</script>
